import { render, staticRenderFns } from "./HeaderSlider.vue?vue&type=template&id=fbbdef0c&scoped=true&"
import script from "./HeaderSlider.vue?vue&type=script&lang=js&"
export * from "./HeaderSlider.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSlider.vue?vue&type=style&index=0&id=fbbdef0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbdef0c",
  null
  
)

export default component.exports